module.exports = __webpack_public_path__ + "static/media/fundo_saopaulo_armadilhaDisseminadoraInseticida.78d602fc.png";